import { PropsWithChildren } from 'react';
import css from './animated-container.module.scss';

interface AnimatedContainerProps {
  onClick?: () => void;
}

export default function AnimatedContainer({ children, onClick }: PropsWithChildren<AnimatedContainerProps>) {
  return (
    <div className={css.animatedContainer} onClick={onClick} aria-hidden>
      {children}
    </div>
  );
}
